import axios from 'axios'
import { config, configMultipart, url } from '../../index'
import { currentDateTime, formatDateForServer, clearUserHtml } from '@/utils/utils'
import { showAlertWarning } from '@/utils/store/alert'
import moment from 'moment'

import dictionariesApi from '@/api/dictionariesApi'
import pollsApi from '@/api/pollsApi'

const mimeTypes = ['image/jpeg', 'image/gif', 'image/pjpeg', 'image/png', 'image/svg+xml', 'image/tiff', 'image/vnd.microsoft.icon', 'image/vnd.wap.wbmp', 'image/webp']
const systemCreator = {
  name: 'Интекс',
  avatar: {
    /* свойство file_size нужно для прохождения доп проверки в компоненте */
    file_size: 1,
    url: '/img/system-avatar.svg'
  }
}
// приводим посты в приличный вид, для отрисовки
function parsedPosts (posts) {
  return posts.map(post => {
    return {
      ...post,
      owner: post.owner_id && post.owner !== undefined ? post.owner : systemCreator,
      isControlsActive: false,
      isLoading: false,
      itemable: post.itemable !== null ? {
        ...post.itemable,
        files: post.itemable.files ? post.itemable.files.filter(file => {
          if (!(mimeTypes.indexOf(file.content_type) + 1)) {
            return file
          }
        }) : [],
        /* выносим изображения в отдельное свойство, так-как они выводятся отдельно */
        images: post.itemable.files ? post.itemable.files.filter(file => {
          if (mimeTypes.indexOf(file.content_type) + 1) {
            return file
          }
        }).map((file, i) => {
          /* при записи вложенных изображений к посту добавляем image_id попорядку
          для того чтобы модалка предпросмотра корректно работала (следующее/предыдущее) */
          return { ...file, image_id: i }
        }) : []
      } : {}
    }
  })
}
// функция расширения постов доп данными, потому что чудесное апи не может сразу присылать всё что нужно для отрисовки
const extendPosts = posts => {
  return new Promise((resolve, reject) => {
    const extendedPosts = []
    async function handler () {
      for (const post of posts) {
        const type = post.itemable_type.split('\\').pop()
        if (type === 'Poll') {
          await pollsApi.getPollAnswers(post.itemable.id).then(response => {
            post.itemable.answers = response.data?.data ?? []
            extendedPosts.push(post)
          }).catch(error => {
            console.log('ошибка расширения опроса ответами', error.response ?? error)
            reject(error.response ?? error)
          })
        } else {
          extendedPosts.push(post)
        }
      }
    }
    handler().then(() => {
      resolve(extendedPosts)
    }).catch(error => {
      reject(error)
    })
  })
}

const state = () => ({
  posts: [],
  is_footer_active: false,
  eventModal: {
    updatedId: null,
    active: false,
    isLoading: false,
    activeMoreUsers: false,
    name: '',
    description: '',
    attachment: {
      linkTooltip: {
        active: false,
        text: '',
        url: '',
        textValid: {},
        urlValid: {}
      },
      tagTooltip: {
        active: false,
        text: '',
        valid: {}
      },
      files: [],
      tags: [],
      filesToRemove: []
    },
    date_start: currentDateTime(),
    date_finish: currentDateTime(),
    place: '',
    reminder: {
      value: { id: null, name: 'Не выбрано' },
      options: [
        { id: 1, name: 'за 1 неделю' },
        { id: 2, name: 'за 1 день' },
        { id: 3, name: 'за 1 час' }
      ]
    },
    recipients: {
      active: false,
      userSearch: '',
      tabs: {
        users: [],
        groups: [],
        departments: []
      },
      selected: []
    },
    validation: {
      name: { type: null, message: '' }
    }
  },
  pollModal: {
    active: false,
    updatedId: null,
    isLoading: false,
    description: '',
    question: '',
    isOpen: false,
    isMultiple: false,
    optionsError: null,
    // нужно хранить удаленные варианты, если опрос редактируется, чтобы удалить их с бека
    optionsToRemove: [],
    options: [
      { id: null, name: '' },
      { id: null, name: '' }
    ],
    answers: null,
    recipients: {
      active: false,
      userSearch: '',
      tabs: {
        users: [],
        groups: [],
        departments: []
      },
      selected: []
    },
    validation: {
      name: { type: null, message: '' }
    }
  },
  messageArea: {
    updatedId: null,
    message: '',
    attachment: {
      linkTooltip: {
        active: false,
        text: '',
        url: '',
        textValid: {},
        urlValid: {}
      },
      tagTooltip: {
        active: false,
        text: '',
        valid: {}
      },
      files: [],
      tags: [],
      filesToRemove: []
    },
    recipients: {
      active: false,
      userSearch: '',
      tabs: {
        users: [],
        groups: [],
        departments: []
      },
      selected: []
    }
  },
  searchValue: '',
  filter: {
    active: false,
    date_from: '',
    date_to: '',
    author: { id: null, name: '' },
    recipient: { id: null, name: '' }
  },
  currentPage: 1,
  isLoading: true
})

const getters = {
  getFeedPosts: state => state.posts,
  getFeedFooterActive: state => state.is_footer_active,
  getFeedMessageArea: state => state.messageArea,
  getFeedMessage: state => state.messageArea.message,
  getFeedMessageAttachment: state => state.messageArea.attachment,
  getFeedRecipients: state => state.messageArea.recipients,
  getFeedFilter: state => state.filter,
  getFeedEventModal: state => state.eventModal,
  getFeedPollModal: state => state.pollModal,
  getFeedIsLoading: state => state.isLoading
}

const mutations = {
  ACTIVE_FEED_EVENT_MORE_USERS: (state) => {
    if (state.eventModal.activeMoreUsers) {
      state.eventModal.activeMoreUsers = false
    } else {
      state.eventModal.activeMoreUsers = true
    }
  },
  CLOSE_FEED_EVENT_MORE_USERS: (state) => {
    state.eventModal.activeMoreUsers = false
  },
  SET_FEED_POSTS: (state, posts) => {
    if (posts !== undefined) {
      state.posts = parsedPosts(posts)
      state.isLoading = false
    }
  },
  SET_MORE_FEED_POSTS: (state, posts) => {
    if (posts !== undefined) {
      state.posts = state.posts.concat(parsedPosts(posts))
    }
  },
  SET_FEED_CURRENT_PAGE: (state, page) => {
    state.currentPage = Number(page)
  },
  RESET_FEED_CONTENT: (state) => {
    state.currentPage = 1
    state.posts = []
  },
  SET_FEED_IS_LOADING: (state) => {
    state.isLoading = true
  },
  SHOW_FEED_MESSAGE_AREA: (state) => {
    state.is_footer_active = true
  },
  HIDE_FEED_MESSAGE_AREA: (state) => {
    state.is_footer_active = false
  },
  SET_FEED_MESSAGE_VALUE: (state, message) => {
    state.messageArea.message = message
  },
  FEED_MESSAGE_ATTACH_FILES: (state, files) => {
    const newFiles = Object.values(files)
    state.messageArea.attachment.files = state.messageArea.attachment.files.concat(newFiles)
  },
  FEED_MESSAGE_REMOVE_FILE: (state, data) => {
    // из data берем индекс, потому что удаляем из вложений при создании сообщения, id у файлов нет
    // id файла нужно для удаление с сервера
    const files = state.messageArea.attachment.files
    files.splice(data.index, 1)
    state.messageArea.attachment.files = files
    // id файлов пушим в массив для последующего удаления с сервера (id есть только если сообщение редактируется)
    if (data.id !== undefined) {
      state.messageArea.attachment.filesToRemove.push(data.id)
    }
  },
  TOGGLE_FEED_MESSAGE_LINK_TOOLTIP: (state) => {
    state.messageArea.attachment.linkTooltip.active = !state.messageArea.attachment.linkTooltip.active
  },
  CLOSE_FEED_MESSAGE_LINK_TOOLTIP: (state) => {
    state.messageArea.attachment.linkTooltip.textValid = {}
    state.messageArea.attachment.linkTooltip.urlValid = {}
    state.messageArea.attachment.linkTooltip.text = ''
    state.messageArea.attachment.linkTooltip.url = ''
    state.messageArea.attachment.linkTooltip.active = false
  },
  SET_FEED_MESSAGE_LINK_TEXT: (state, text) => {
    state.messageArea.attachment.linkTooltip.text = text
  },
  SET_FEED_MESSAGE_LINK_URL: (state, url) => {
    state.messageArea.attachment.linkTooltip.url = url
  },
  SET_FEED_MESSAGE_LINK_TEXT_VALID: (state, valid) => {
    state.messageArea.attachment.linkTooltip.textValid = valid
  },
  SET_FEED_MESSAGE_LINK_URL_VALID: (state, valid) => {
    state.messageArea.attachment.linkTooltip.urlValid = valid
  },
  TOGGLE_FEED_MESSAGE_TAG_TOOLTIP: (state) => {
    state.messageArea.attachment.tagTooltip.active = !state.messageArea.attachment.tagTooltip.active
  },
  CLOSE_FEED_MESSAGE_TAG_TOOLTIP: (state) => {
    state.messageArea.attachment.tagTooltip.valid = {}
    state.messageArea.attachment.tagTooltip.text = ''
    state.messageArea.attachment.tagTooltip.active = false
  },
  SET_FEED_MESSAGE_TAG_TEXT: (state, text) => {
    state.messageArea.attachment.tagTooltip.text = text.replace(/\s/g, '')
  },
  FEED_MESSAGE_ATTACH_TAG: (state) => {
    const tagText = state.messageArea.attachment.tagTooltip.text
    state.messageArea.attachment.tags.push(tagText)
  },
  FEED_MESSAGE_REMOVE_TAG: (state, index) => {
    const tags = [...state.messageArea.attachment.tags]
    tags.splice(index, 1)
    state.messageArea.attachment.tags = tags
  },
  SET_FEED_MESSAGE_TAG_VALID: (state, valid) => {
    state.messageArea.attachment.tagTooltip.valid = valid
  },
  CLEAR_FEED_MESSAGE_ATTACHMENT_VALID: (state) => {
    state.messageArea.attachment.linkTooltip.textValid = {}
    state.messageArea.attachment.linkTooltip.urlValid = {}
    state.messageArea.attachment.tagTooltip.valid = {}
  },
  CLEAR_FEED_MESSAGE_AREA: (state) => {
    state.messageArea.updatedId = null
    state.messageArea.message = ''
    state.messageArea.attachment.files = []
    state.messageArea.attachment.tags = []
    state.messageArea.attachment.filesToRemove = []
    state.messageArea.recipients.selected = []
    state.messageArea.recipients.tabs.users.forEach(user => {
      user.is_checked = false
    })
    state.messageArea.recipients.tabs.groups.forEach(group => {
      group.is_checked = false
    })
    state.messageArea.recipients.tabs.departments.forEach(department => {
      department.is_checked = false
    })
  },
  SET_FEED_MESSAGE_RECIPIENTS_USERS_OPTIONS: (state, users) => {
    const selectedArray = state.messageArea.recipients.selected

    state.messageArea.recipients.tabs.users = users.map(user => {
      return {
        ...user,
        // доп id нужен так как в selected будут вперемешку юзеры, группы и отделы (id могут пересекаться)
        recipient_id: `${user.id}_user`,
        // так как список юзеров переустанавливается при поиске, нужно сверять выбранных и активировать чекбокс
        is_checked: selectedArray.some(item => item.recipient_id === `${user.id}_user`)
      }
    })
  },
  SET_FEED_MESSAGE_RECIPIENTS_GROUPS_OPTIONS: (state, groups) => {
    state.messageArea.recipients.tabs.groups = groups.map(group => {
      return {
        ...group,
        // доп id нужен так как в selected будут вперемешку юзеры, группы и отделы (id могут пересекаться)
        recipient_id: `${group.id}_group`,
        is_checked: false
      }
    })
  },
  SET_FEED_MESSAGE_RECIPIENTS_DEPARTMENTS_OPTIONS: (state, departments) => {
    state.messageArea.recipients.tabs.departments = departments.map(department => {
      return {
        ...department,
        // доп id нужен так как в selected будут вперемешку юзеры, группы и отделы (id могут пересекаться)
        recipient_id: `${department.id}_department`,
        is_checked: false
      }
    })
  },
  '[feed] SET_USER_RECIPIENT_SEARCH': (state, value) => {
    state.messageArea.recipients.userSearch = value
  },
  TOGGLE_FEED_SELECTED_RECIPIENT: (state, recipient) => {
    const userOptionArray = state.messageArea.recipients.tabs.users
    const groupOptionArray = state.messageArea.recipients.tabs.groups
    const departmentOptionArray = state.messageArea.recipients.tabs.departments
    const selectedArray = state.messageArea.recipients.selected
    const modifier = recipient.recipient_id.split('_').pop()

    switch (modifier) {
      case 'user':
        state.messageArea.recipients.tabs.users = userOptionArray.map(option => {
          if (option.recipient_id === recipient.recipient_id) {
            // пушим пользователя если массив выбранных его не содержит
            if (!selectedArray.some(item => item.recipient_id === option.recipient_id)) {
              selectedArray.push(option)
            } else {
              state.messageArea.recipients.selected = selectedArray.filter(item => item.recipient_id !== option.recipient_id)
            }
            return { ...option, is_checked: !option.is_checked }
          } else return option
        })
        break
      case 'group':
        state.messageArea.recipients.tabs.groups = groupOptionArray.map(option => {
          if (option.recipient_id === recipient.recipient_id) {
            // пушим пользователя если массив выбранных его не содержит
            if (!selectedArray.some(item => item.recipient_id === option.recipient_id)) {
              selectedArray.push(option)
            } else {
              state.messageArea.recipients.selected = selectedArray.filter(item => item.recipient_id !== option.recipient_id)
            }
            return { ...option, is_checked: !option.is_checked }
          } else return option
        })
        break
      case 'department':
        state.messageArea.recipients.tabs.departments = departmentOptionArray.map(option => {
          if (option.recipient_id === recipient.recipient_id) {
            // пушим пользователя если массив выбранных его не содержит
            if (!selectedArray.some(item => item.recipient_id === option.recipient_id)) {
              selectedArray.push(option)
            } else {
              state.messageArea.recipients.selected = selectedArray.filter(item => item.recipient_id !== option.recipient_id)
            }
            return { ...option, is_checked: !option.is_checked }
          } else return option
        })
        break
      default: break
    }
  },
  TOGGLE_FEED_MESSAGE_RECIPIENTS: (state) => {
    state.messageArea.recipients.active = !state.messageArea.recipients.active
  },
  CLOSE_FEED_MESSAGE_RECIPIENTS: (state) => {
    state.messageArea.recipients.active = false
  },
  TOGGLE_FEED_POST_CONTROLS: (state, postId) => {
    state.posts.forEach((elem) => {
      if (postId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (postId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  CLOSE_FEED_POST_CONTROLS: (state) => {
    state.posts.forEach((elem) => {
      elem.isControlsActive = false
    })
  },
  SET_FEED_POST_DATA_TO_UPDATE: (state, data) => {
    state.messageArea.updatedId = data.itemableId
    state.messageArea.message = data.message
    state.messageArea.attachment.files = data.files
    state.messageArea.attachment.tags = data.tags
  },
  REMOVE_FEED_POST_FROM_STATE: (state, postId) => {
    state.posts = [...state.posts].filter(post => {
      return post.id !== postId
    })
  },
  SET_FEED_EVENT_RECIPIENTS_USERS_OPTIONS: (state, users) => {
    const alreadySelected = state.eventModal.recipients.selected

    state.eventModal.recipients.tabs.users = users.map(user => {
      return {
        ...user,
        // доп id нужен так как в selected будут вперемешку юзеры, группы и отделы (id могут пересекаться)
        recipient_id: `${user.id}_user`,
        // если уже выбран, отмечаем чекбокс
        is_checked: alreadySelected.some(item => item.recipient_id === `${user.id}_user`)
      }
    })
  },
  SET_FEED_EVENT_RECIPIENTS_GROUPS_OPTIONS: (state, groups) => {
    const alreadySelected = state.eventModal.recipients.selected

    state.eventModal.recipients.tabs.groups = groups.map(group => {
      return {
        ...group,
        // доп id нужен так как в selected будут вперемешку юзеры, группы и отделы (id могут пересекаться)
        recipient_id: `${group.id}_group`,
        // если уже выбран, отмечаем чекбокс
        is_checked: alreadySelected.some(item => item.recipient_id === `${group.id}_group`)
      }
    })
  },
  SET_FEED_EVENT_RECIPIENTS_DEPARTMENTS_OPTIONS: (state, departments) => {
    const alreadySelected = state.eventModal.recipients.selected

    state.eventModal.recipients.tabs.departments = departments.map(department => {
      return {
        ...department,
        // доп id нужен так как в selected будут вперемешку юзеры, группы и отделы (id могут пересекаться)
        recipient_id: `${department.id}_department`,
        // если уже выбран, отмечаем чекбокс
        is_checked: alreadySelected.some(item => item.recipient_id === `${department.id}_department`)
      }
    })
  },

  // создание мероприятия
  SHOW_FEED_EVENT_MODAL: (state) => {
    state.eventModal.active = true
  },
  '[feed-event] REQUEST_START': state => {
    state.eventModal.isLoading = true
  },
  '[feed-event] REQUEST_SUCCESS': state => {
    state.eventModal.isLoading = false
  },
  '[feed-event] REQUEST_FAILURE': state => {
    state.eventModal.isLoading = false
  },
  CLOSE_FEED_EVENT_MODAL: (state) => {
    state.eventModal.active = false
  },
  CLEAR_FEED_EVENT_MODAL: (state) => {
    state.eventModal.updatedId = null
    state.eventModal.name = ''
    state.eventModal.description = ''
    state.eventModal.attachment.files = []
    state.eventModal.attachment.tags = []
    state.eventModal.date_start = currentDateTime()
    state.eventModal.date_finish = currentDateTime()
    state.eventModal.place = ''
    state.eventModal.reminder.value = {
      id: null,
      name: 'Не выбрано'
    }
    state.eventModal.activeMoreUsers = false
    state.eventModal.recipients.active = false
    state.eventModal.recipients.selected = []
    state.eventModal.recipients.tabs.users.forEach(user => {
      user.is_checked = false
    })
    state.eventModal.recipients.tabs.groups.forEach(group => {
      group.is_checked = false
    })
    state.eventModal.recipients.tabs.departments.forEach(department => {
      department.is_checked = false
    })
  },
  SET_FEED_EVENT_NAME: (state, name) => {
    state.eventModal.name = name
  },
  SET_FEED_EVENT_DESCRIPTION: (state, description) => {
    state.eventModal.description = description
  },
  FEED_EVENT_ATTACH_FILES: (state, files) => {
    state.eventModal.attachment.files = Object.values(files)
  },
  FEED_EVENT_REMOVE_FILE: (state, data) => {
    // из data берем индекс, потому что удаляем из вложений при создании сообщения, id у файлов нет
    // id файла нужно для удаление с сервера
    const files = state.eventModal.attachment.files
    files.splice(data.index, 1)
    state.eventModal.attachment.files = files
    // id файлов пушим в массив для последующего удаления с сервера (id есть только если сообщение редактируется)
    if (data.id !== undefined) {
      state.eventModal.attachment.filesToRemove.push(data.id)
    }
  },
  TOGGLE_FEED_EVENT_LINK_TOOLTIP: (state) => {
    state.eventModal.attachment.linkTooltip.active = !state.eventModal.attachment.linkTooltip.active
  },
  CLOSE_FEED_EVENT_LINK_TOOLTIP: (state) => {
    state.eventModal.attachment.linkTooltip.textValid = {}
    state.eventModal.attachment.linkTooltip.urlValid = {}
    state.eventModal.attachment.linkTooltip.text = ''
    state.eventModal.attachment.linkTooltip.url = ''
    state.eventModal.attachment.linkTooltip.active = false
  },
  SET_FEED_EVENT_LINK_TEXT: (state, text) => {
    state.eventModal.attachment.linkTooltip.text = text
  },
  SET_FEED_EVENT_LINK_URL: (state, url) => {
    state.eventModal.attachment.linkTooltip.url = url
  },
  SET_FEED_EVENT_LINK_TEXT_VALID: (state, valid) => {
    state.eventModal.attachment.linkTooltip.textValid = valid
  },
  SET_FEED_EVENT_LINK_URL_VALID: (state, valid) => {
    state.eventModal.attachment.linkTooltip.urlValid = valid
  },
  TOGGLE_FEED_EVENT_TAG_TOOLTIP: (state) => {
    state.eventModal.attachment.tagTooltip.active = !state.eventModal.attachment.tagTooltip.active
  },
  CLOSE_FEED_EVENT_TAG_TOOLTIP: (state) => {
    state.eventModal.attachment.tagTooltip.valid = {}
    state.eventModal.attachment.tagTooltip.text = ''
    state.eventModal.attachment.tagTooltip.active = false
  },
  SET_FEED_EVENT_TAG_TEXT: (state, text) => {
    state.eventModal.attachment.tagTooltip.text = text.replace(/\s/g, '')
  },
  FEED_EVENT_ATTACH_TAG: (state) => {
    const tagText = state.eventModal.attachment.tagTooltip.text
    state.eventModal.attachment.tags.push(tagText)
  },
  FEED_EVENT_REMOVE_TAG: (state, index) => {
    const tags = [...state.eventModal.attachment.tags]
    tags.splice(index, 1)
    state.eventModal.attachment.tags = tags
  },
  SET_FEED_EVENT_TAG_VALID: (state, valid) => {
    state.eventModal.attachment.tagTooltip.valid = valid
  },
  CLEAR_FEED_EVENT_ATTACHMENT_VALID: (state) => {
    state.eventModal.attachment.linkTooltip.textValid = {}
    state.eventModal.attachment.linkTooltip.urlValid = {}
    state.eventModal.attachment.tagTooltip.valid = {}
  },
  SET_FEED_EVENT_START_DATE: (state, date) => {
    state.eventModal.date_start = date
  },
  SET_FEED_EVENT_FINISH_DATE: (state, date) => {
    state.eventModal.date_finish = date
  },
  SET_FEED_EVENT_PLACE: (state, place) => {
    state.eventModal.place = place
  },
  SET_FEED_EVENT_REMINDER: (state, reminder) => {
    state.eventModal.reminder.value = reminder
  },
  '[feed-event] SET_USER_RECIPIENT_SEARCH': (state, value) => {
    state.eventModal.recipients.userSearch = value
  },
  TOGGLE_FEED_EVENT_SELECTED_RECIPIENT: (state, recipient) => {
    const userOptionArray = state.eventModal.recipients.tabs.users
    const groupOptionArray = state.eventModal.recipients.tabs.groups
    const departmentOptionArray = state.eventModal.recipients.tabs.departments
    const selectedArray = state.eventModal.recipients.selected
    const modifier = recipient.recipient_id.split('_').pop()

    switch (modifier) {
      case 'user':
        state.eventModal.recipients.tabs.users = userOptionArray.map(option => {
          if (option.recipient_id === recipient.recipient_id) {
            // пушим пользователя если массив выбранных его не содержит
            if (!selectedArray.some(item => item.recipient_id === option.recipient_id)) {
              selectedArray.push(option)
            } else {
              state.eventModal.recipients.selected = selectedArray.filter(item => item.recipient_id !== option.recipient_id)
            }
            return { ...option, is_checked: !option.is_checked }
          } else return option
        })
        break
      case 'group':
        state.eventModal.recipients.tabs.groups = groupOptionArray.map(option => {
          if (option.recipient_id === recipient.recipient_id) {
            // пушим пользователя если массив выбранных его не содержит
            if (!selectedArray.some(item => item.recipient_id === option.recipient_id)) {
              selectedArray.push(option)
            } else {
              state.eventModal.recipients.selected = selectedArray.filter(item => item.recipient_id !== option.recipient_id)
            }
            return { ...option, is_checked: !option.is_checked }
          } else return option
        })
        break
      case 'department':
        state.eventModal.recipients.tabs.departments = departmentOptionArray.map(option => {
          if (option.recipient_id === recipient.recipient_id) {
            // пушим пользователя если массив выбранных его не содержит
            if (!selectedArray.some(item => item.recipient_id === option.recipient_id)) {
              selectedArray.push(option)
            } else {
              state.eventModal.recipients.selected = selectedArray.filter(item => item.recipient_id !== option.recipient_id)
            }
            return { ...option, is_checked: !option.is_checked }
          } else return option
        })
        break
      default: break
    }
  },
  TOGGLE_FEED_EVENT_RECIPIENTS: (state) => {
    state.eventModal.recipients.active = !state.eventModal.recipients.active
  },
  CLOSE_FEED_EVENT_RECIPIENTS: (state) => {
    state.eventModal.recipients.active = false
  },
  SET_FEED_EVENT_VALIDATION: (state, errors) => {
    state.eventModal.validation.name = { type: 'error', message: errors.name[0] }
  },
  CLEAR_FEED_EVENT_VALIDATION: (state) => {
    const validationState = state.eventModal.validation

    for (const key in validationState) {
      validationState[key].type = null
      validationState[key].message = ''
    }
  },
  SET_FEED_EVENT_MODAL_DATA_TO_UPDATE: (state, data) => {
    const eventModal = state.eventModal
    eventModal.updatedId = data.id
    eventModal.name = data.name
    eventModal.description = data.description
    eventModal.attachment.files = data.files ? data.files : []
    eventModal.attachment.tags = data.tags ? data.tags : []
    eventModal.date_start = data.start_at
    eventModal.date_finish = data.end_at
    eventModal.place = data.address
    eventModal.reminder.value = data.remind_at_object

    // собираем из получателей данные для компонента AppMessageRecipients в поле (выбрано) и отмечаем их в общем списке
    // сначала список очищаем, иначе если модалку закрыли крестиком (без очистки полей), то возникнут дубликаты
    state.eventModal.recipients.selected = []
    const recipientsSelected = state.eventModal.recipients.selected

    if (data.users) {
      data.users.forEach(user => {
        recipientsSelected.push({
          id: user.id,
          profile: {
            name: user.profile.name,
            surname: user.profile.surname,
            patronymic: user.profile.patronymic,
            full_name: user.profile.full_name
          },
          name: user.profile.name,
          surname: user.profile.surname,
          patronymic: user.profile.patronymic,
          recipient_id: `${user.id}_user`,
          is_checked: true
        })
        if (!state.eventModal.recipients.tabs.users.some(item => item.id === user.id)) {
          state.eventModal.recipients.tabs.users.push(user)
        }
        // отмечаем в табах
        state.eventModal.recipients.tabs.users.forEach(recipient => {
          if (recipient.id === user.id) {
            recipient.is_checked = true
          }
        })
      })
    }

    if (data.groups) {
      data.groups.forEach(group => {
        recipientsSelected.push({
          id: group.id,
          name: group.name,
          color: group.color,
          recipient_id: `${group.id}_group`,
          is_checked: true
        })
        state.eventModal.recipients.tabs.groups.forEach(recipient => {
          if (recipient.id === group.id) {
            recipient.is_checked = true
          }
        })
      })
    }

    if (data.departments) {
      data.departments.forEach(department => {
        recipientsSelected.push({
          id: department.id,
          name: department.name,
          recipient_id: `${department.id}_department`,
          is_checked: true
        })
        state.eventModal.recipients.tabs.departments.forEach(recipient => {
          if (recipient.id === department.id) {
            recipient.is_checked = true
          }
        })
      })
    }
  },

  // модалка опроса
  '[feed-poll] OPEN_MODAL': state => {
    state.pollModal.active = true
  },
  '[feed-poll] CLOSE_MODAL': state => {
    state.pollModal.active = false
  },
  '[feed-poll] CLEAR_MODAL': state => {
    const modal = state.pollModal

    modal.updatedId = null
    modal.description = null
    modal.question = null
    modal.isOpen = false
    modal.isMultiple = false
    modal.optionsError = null
    modal.optionsToRemove = []
    modal.options = [
      { id: null, name: '' },
      { id: null, name: '' }
    ]
    modal.answers = null
    modal.recipients.selected = []
    modal.recipients.tabs.users.forEach(user => {
      user.is_checked = false
    })
    modal.recipients.tabs.groups.forEach(group => {
      group.is_checked = false
    })
    modal.recipients.tabs.departments.forEach(department => {
      department.is_checked = false
    })
    modal.validation = {
      name: { type: null, message: '' }
    }
  },
  '[feed-poll] SET_OPTIONS_ERROR': state => {
    state.pollModal.optionsError = 'Первые два варианта ответа должны быть заполнены!'
  },
  '[feed-poll] CLEAR_OPTIONS_ERROR': state => {
    state.pollModal.optionsError = null
  },
  '[feed-poll] MODAL_REQUEST_START': state => {
    state.pollModal.isLoading = true
  },
  '[feed-poll] MODAL_REQUEST_FINISHED': state => {
    state.pollModal.isLoading = false
  },
  '[feed-poll] SET_VALIDATION': (state, errors) => {
    if (errors) {
      if (errors.name) {
        state.pollModal.validation.name = { type: 'error', message: errors.name[0] }
      }
    }
  },
  '[feed-poll] CLEAR_VALIDATION': (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.pollModal.validation.name = { type: null, message: '' }
        break
      default: break
    }
  },
  '[feed-poll] SET_DESCRIPTION': (state, value) => {
    state.pollModal.description = value
  },
  '[feed-poll] SET_QUESTION': (state, value) => {
    state.pollModal.question = value
  },
  '[feed-poll] TOGGLE_OPEN': state => {
    state.pollModal.isOpen = !state.pollModal.isOpen
  },
  '[feed-poll] TOGGLE_MULTIPLE': state => {
    state.pollModal.isMultiple = !state.pollModal.isMultiple
  },
  '[feed-poll] ADD_ANSWER': state => {
    const answer = { id: null, name: '' }
    state.pollModal.options.push(answer)
  },
  '[feed-poll] REMOVE_ANSWER': (state, payload) => {
    if (payload.id) {
      state.pollModal.options = state.pollModal.options.filter(item => item.id !== payload.id)
      state.pollModal.optionsToRemove.push(payload.id)
    } else {
      state.pollModal.options.splice(payload.index, 1)
    }
  },
  '[feed-poll] SET_ANSWER_TEXT': (state, data) => {
    const { payload, value } = data

    if (payload.id) {
      state.pollModal.options.find(item => item.id === payload.id).name = value
    } else {
      state.pollModal.options[payload.index].name = value
    }
  },
  '[feed-poll] SET_USER_RECIPIENT_SEARCH': (state, value) => {
    state.pollModal.recipients.userSearch = value
  },
  '[feed-poll] SET_RECIPIENTS_USERS_OPTIONS': (state, users) => {
    const alreadySelected = state.pollModal.recipients.selected

    state.pollModal.recipients.tabs.users = users.map(user => {
      return {
        ...user,
        // доп id нужен так как в selected будут вперемешку юзеры, группы и отделы (id могут пересекаться)
        recipient_id: `${user.id}_user`,
        // если уже выбран, то отмечаем чекбокс
        is_checked: alreadySelected.some(item => item.recipient_id === `${user.id}_user`)
      }
    })
  },
  '[feed-poll] SET_RECIPIENTS_GROUPS_OPTIONS': (state, groups) => {
    const alreadySelected = state.pollModal.recipients.selected

    state.pollModal.recipients.tabs.groups = groups.map(group => {
      return {
        ...group,
        // доп id нужен так как в selected будут вперемешку юзеры, группы и отделы (id могут пересекаться)
        recipient_id: `${group.id}_group`,
        // если уже выбран, то отмечаем чекбокс
        is_checked: alreadySelected.some(item => item.recipient_id === `${group.id}_group`)
      }
    })
  },
  '[feed-poll] SET_RECIPIENTS_DEPARTMENTS_OPTIONS': (state, departments) => {
    const alreadySelected = state.pollModal.recipients.selected

    state.pollModal.recipients.tabs.departments = departments.map(department => {
      return {
        ...department,
        // доп id нужен так как в selected будут вперемешку юзеры, группы и отделы (id могут пересекаться)
        recipient_id: `${department.id}_department`,
        // если уже выбран, то отмечаем чекбокс
        is_checked: alreadySelected.some(item => item.recipient_id === `${department.id}_department`)
      }
    })
  },
  '[feed-poll] TOGGLE_SELECTED_RECIPIENT': (state, recipient) => {
    const userOptionArray = state.pollModal.recipients.tabs.users
    const groupOptionArray = state.pollModal.recipients.tabs.groups
    const departmentOptionArray = state.pollModal.recipients.tabs.departments
    const selectedArray = state.pollModal.recipients.selected
    const modifier = recipient.recipient_id.split('_').pop()

    switch (modifier) {
      case 'user':
        state.pollModal.recipients.tabs.users = userOptionArray.map(option => {
          if (option.recipient_id === recipient.recipient_id) {
            // пушим пользователя если массив выбранных его не содержит
            if (!selectedArray.some(item => item.recipient_id === option.recipient_id)) {
              selectedArray.push(option)
            } else {
              state.pollModal.recipients.selected = selectedArray.filter(item => item.recipient_id !== option.recipient_id)
            }
            return { ...option, is_checked: !option.is_checked }
          } else return option
        })
        break
      case 'group':
        state.pollModal.recipients.tabs.groups = groupOptionArray.map(option => {
          if (option.recipient_id === recipient.recipient_id) {
            // пушим пользователя если массив выбранных его не содержит
            if (!selectedArray.some(item => item.recipient_id === option.recipient_id)) {
              selectedArray.push(option)
            } else {
              state.pollModal.recipients.selected = selectedArray.filter(item => item.recipient_id !== option.recipient_id)
            }
            return { ...option, is_checked: !option.is_checked }
          } else return option
        })
        break
      case 'department':
        state.pollModal.recipients.tabs.departments = departmentOptionArray.map(option => {
          if (option.recipient_id === recipient.recipient_id) {
            // пушим пользователя если массив выбранных его не содержит
            if (!selectedArray.some(item => item.recipient_id === option.recipient_id)) {
              selectedArray.push(option)
            } else {
              state.pollModal.recipients.selected = selectedArray.filter(item => item.recipient_id !== option.recipient_id)
            }
            return { ...option, is_checked: !option.is_checked }
          } else return option
        })
        break
      default: break
    }
  },
  '[feed-poll] TOGGLE_RECIPIENTS': (state) => {
    state.pollModal.recipients.active = !state.pollModal.recipients.active
  },
  '[feed-poll] CLOSE_RECIPIENTS': (state) => {
    state.pollModal.recipients.active = false
  },
  '[feed-poll] VOTE_REQUEST_START': (state, postId) => {
    state.posts.find(post => {
      return post.id === postId
    }).isLoading = true
  },
  '[feed-poll] VOTE_REQUEST_FINISHED': (state, postId) => {
    state.posts.find(post => {
      return post.id === postId
    }).isLoading = false
  },
  '[feed-poll] UPDATE_VOTED_ANSWERS': (state, payload) => {
    state.posts.find(post => {
      return post.id === payload.postId
    }).itemable.answers = payload.answers
  },
  '[feed-poll] SET_FOR_UPDATE': (state, payload) => {
    const modal = state.pollModal

    modal.updatedId = payload.id
    modal.description = payload.description
    modal.question = payload.name
    modal.isOpen = payload.settings.is_open
    modal.isMultiple = payload.settings.is_multiple
    modal.optionsError = null
    modal.optionsToRemove = []
    modal.options = payload.options
    modal.answers = payload.answers
    // получатели в ответе не приходят, поэтому зачищаем на всякий случай
    modal.recipients.selected = []
    modal.recipients.tabs.users.forEach(user => {
      user.is_checked = false
    })
    modal.recipients.tabs.groups.forEach(group => {
      group.is_checked = false
    })
    modal.recipients.tabs.departments.forEach(department => {
      department.is_checked = false
    })
  },
  // /модалка опроса

  // поиск и фильтрация в ленте
  SET_FEED_SEARCH_VALUE: (state, value) => {
    state.searchValue = value
  },
  TOGGLE_FEED_FILTER: (state) => {
    state.filter.active = !state.filter.active
  },
  CLOSE_FEED_FILTER: (state) => {
    state.filter.active = false
  },
  CLEAR_FEED_FILTER: (state) => {
    state.filter.active = false
    state.filter.date_from = ''
    state.filter.date_to = ''
    state.filter.author = { id: null, name: '' }
    state.filter.recipient = { id: null, name: '' }
  },
  SET_FEED_FILTER_DATE_FROM: (state, date) => {
    state.filter.date_from = date
  },
  SET_FEED_FILTER_DATE_TO: (state, date) => {
    state.filter.date_to = date
  },
  SET_FEED_FILTER_POST_AUTHOR: (state, author) => {
    state.filter.author = author
  },
  SET_FEED_FILTER_POST_RECIPIENT: (state, recipient) => {
    state.filter.recipient = recipient
  },
  // filter
  SET_FEED_LIST_FILTER: (state, filter) => {
    state.filter = filter
  },
  CLEAR_FEED_LIST_FILTER: (state, filter) => {
    state.filter = filter
  }
}

const actions = {
  getFeedPosts ({ commit, state }) {
    // фильтры по умолчанию чтобы выводить в ленту только сообщения и уведомления об устройстве сотрудников
    const defaultFilter = 'search[type]=UserProcess,EventMessage,Activity,Poll'
    const expands = 'expand=itemable,owner,comments'

    const searchFilter = state.searchValue ? `search[content]=${state.searchValue}` : ''
    const dateFrom = state.filter.date_from ? `search[from_at]=${state.filter.date_from}` : ''
    const dateTo = state.filter.date_to ? `search[end_at]=${state.filter.date_to}` : ''
    const author = state.filter.author.id ? `search[owner]=${state.filter.author.id}` : ''
    // для фильтра по получателю еще нет запроса
    /* const recipient = state.filter.recipient.id ? `filter[]=${state.filter.recipient.id}` : '' */

    axios.get(`${url}/event-posts?sort=-created_at&${defaultFilter}&${expands}&${searchFilter}&${dateFrom}&${dateTo}&${author}`, config).then(response => {
      extendPosts(response.data.data).then(extendedPosts => {
        commit('SET_FEED_POSTS', extendedPosts)
        commit('SET_FEED_CURRENT_PAGE', response.headers['x-pagination-current-page'])
      })
    }).catch(error => {
      console.log('Ошибка получения постов:', error)
    })
  },
  getFeedPostsNextPage ({ commit, state }) {
    // фильтры по умолчанию чтобы выводить в ленту только сообщения и уведомления об устройстве сотрудников
    const defaultFilter = 'search[type]=UserProcess,EventMessage,Activity,Poll'
    const expands = 'expand=itemable,owner'

    const searchFilter = state.searchValue ? `search[content]=${state.searchValue}` : ''
    const dateFrom = state.filter.date_from ? `search[from_at]=${state.filter.date_from}` : ''
    const dateTo = state.filter.date_to ? `search[end_at]=${state.filter.date_to}` : ''
    const author = state.filter.author.id ? `search[owner]=${state.filter.author.id}` : ''
    // для фильтра по получателю еще нет запроса
    /* const recipient = state.filter.recipient.id ? `filter[]=${state.filter.recipient.id}` : '' */
    const page = state.currentPage + 1

    axios.get(`${url}/event-posts?sort=-created_at&${defaultFilter}&${expands}&${searchFilter}&${dateFrom}&${dateTo}&${author}&page=${page}`, config).then(response => {
      extendPosts(response.data.data).then(extendedPosts => {
        commit('SET_MORE_FEED_POSTS', extendedPosts)
        commit('SET_FEED_CURRENT_PAGE', response.headers['x-pagination-current-page'])
        console.log(`next-page| posts:${state.posts.length}, page:${state.currentPage}`)
      })
    }).catch(error => {
      console.log('Ошибка пагинации постов:', error)
    })
  },
  resetFeedContent ({ commit }) {
    commit('RESET_FEED_CONTENT')
  },
  showFeedMessageArea ({ commit }) {
    commit('SHOW_FEED_MESSAGE_AREA')
  },
  setFeedMessageValue ({ commit }, message) {
    commit('SET_FEED_MESSAGE_VALUE', message)
  },
  // список получателей сообщения из ленты и участников мероприятия
  getFeedRecipientsOptions ({ commit, state }) {
    const getGroups = axios.get(`${url}/groups?per-page=99999?fields=id,name,color&expand=users`, config)
    // пока нет expand для модели departments, users получаются во время отправки сообщения путем запросов к каждому
    // выбранному отделу
    const getDepartments = dictionariesApi.getDepartmentList()

    axios.all([getGroups, getDepartments]).then(axios.spread((getGroupsResponse, getDepartmentsResponse) => {
      commit('SET_FEED_MESSAGE_RECIPIENTS_GROUPS_OPTIONS', getGroupsResponse.data.data)
      commit('SET_FEED_EVENT_RECIPIENTS_GROUPS_OPTIONS', getGroupsResponse.data.data)
      commit('[feed-poll] SET_RECIPIENTS_GROUPS_OPTIONS', getGroupsResponse.data.data)

      commit('SET_FEED_MESSAGE_RECIPIENTS_DEPARTMENTS_OPTIONS', getDepartmentsResponse.data.data)
      commit('SET_FEED_EVENT_RECIPIENTS_DEPARTMENTS_OPTIONS', getDepartmentsResponse.data.data)
      commit('[feed-poll] SET_RECIPIENTS_DEPARTMENTS_OPTIONS', getDepartmentsResponse.data.data)
    }))
  },
  '[feed] getRecipientUserOptions' ({ commit, state }) {
    const userParams = {
      pagination: {
        currentPage: 1,
        perPage: 40
      },
      filter: {
        search: `search[all]=${state.messageArea.recipients.userSearch}`
      }
    }
    dictionariesApi.getUserOptionList(userParams).then(response => {
      commit('SET_FEED_MESSAGE_RECIPIENTS_USERS_OPTIONS', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка сотрудников для компонента "получатели"', error.response ? error.response : error)
    })
  },
  '[feed] setUserRecipientSearch' ({ dispatch, commit }, value) {
    commit('[feed] SET_USER_RECIPIENT_SEARCH', value)
    dispatch('[feed] getRecipientUserOptions')
  },
  toggleFeedSelectedRecipient ({ commit }, recipient) {
    commit('TOGGLE_FEED_SELECTED_RECIPIENT', recipient)
  },
  toggleFeedRecipientsSelect ({ commit }) {
    commit('TOGGLE_FEED_MESSAGE_RECIPIENTS')
  },
  closeFeedRecipientsSelect ({ commit }) {
    commit('CLOSE_FEED_MESSAGE_RECIPIENTS')
  },
  sendFeedMessage ({ commit, state }) {
    if (!state.messageArea.updatedId) {
      const message = clearUserHtml(state.messageArea.message, false)

      const recipientDepartments = state.messageArea.recipients.selected.filter(item => {
        return item.recipient_id.split('_').pop() === 'department'
      }).map(department => {
        return department.id
      })
      const recipientGroups = state.messageArea.recipients.selected.filter(item => {
        return item.recipient_id.split('_').pop() === 'group'
      }).map(group => {
        return group.id
      })
      const recipientUsers = state.messageArea.recipients.selected.filter(item => {
        return item.recipient_id.split('_').pop() === 'user'
      }).map(user => {
        return user.id
      })

      // let tags = state.messageArea.attachment.tags.join('&tags[]=')
      // tags = tags.length !== 0 ? 'tags[]=' + tags : ''
      const formData = new FormData()
      const files = state.messageArea.attachment.files

      for (let i = 0; i < files.length; ++i) {
        formData.append('files[]', files[i])
      }
      formData.append('content', message)
      formData.append('tags[]', state.messageArea.attachment.tags)
      formData.append('user_ids[]', recipientUsers)
      formData.append('group_ids[]', recipientGroups)
      formData.append('department_ids[]', recipientDepartments)

      axios.post(`${url}/event-messages`, formData, configMultipart).then(response => {
        commit('RESET_FEED_CONTENT')
        commit('CLEAR_FEED_MESSAGE_AREA')
        commit('CLOSE_FEED_MESSAGE_RECIPIENTS')
        commit('HIDE_FEED_MESSAGE_AREA')
        commit('CLEAR_FEED_FILTER')
        this.dispatch('getFeedPosts')
      }).catch(error => {
        showAlertWarning(error.response.data.data.message)
      })
    } else {
      // для добавления файлов нужно отправлять POST на /event-messages/{ itemable_id }/upload
      const itemableId = state.messageArea.updatedId
      const updateData = {
        content: clearUserHtml(state.messageArea.message)
      }
      let tags = state.messageArea.attachment.tags.join('&tags[]=')
      tags = tags.length !== 0 ? 'tags[]=' + tags : ''
      const formData = new FormData()
      // выбираем только вновь добавленные файлы у которых нет id чтобы не заливать дубли на серв
      const newFiles = state.messageArea.attachment.files.filter(file => {
        return file.id === undefined
      })
      for (let i = 0; i < newFiles.length; ++i) {
        formData.append('files[]', newFiles[i])
      }

      const removeMessageFiles = state.messageArea.attachment.filesToRemove.map(id => {
        return axios.delete(`${url}/files/${id}`, config)
      })
      const attachNewFiles = newFiles.length !== 0 ? axios.post(`${url}/event-messages/${itemableId}/upload`, formData, configMultipart) : false
      const updateMessageData = axios.put(`${url}/event-messages/${itemableId}?&${tags}`, updateData, config)

      axios.all([removeMessageFiles, attachNewFiles, updateMessageData]).then(response => {
        commit('RESET_FEED_CONTENT')
        commit('CLEAR_FEED_MESSAGE_AREA')
        commit('CLOSE_FEED_MESSAGE_RECIPIENTS')
        commit('HIDE_FEED_MESSAGE_AREA')
        commit('CLEAR_FEED_FILTER')
        this.dispatch('getFeedPosts')
      }).catch(error => {
        console.log('ошибка редактирования поста в ленте', error.response.data.validation)
      })
    }
  },
  cancelSendFeedMessage ({ commit }) {
    commit('CLEAR_FEED_MESSAGE_AREA')
    commit('CLOSE_FEED_MESSAGE_RECIPIENTS')
    commit('HIDE_FEED_MESSAGE_AREA')
    commit('CLOSE_FEED_MESSAGE_LINK_TOOLTIP')
    commit('CLOSE_FEED_MESSAGE_TAG_TOOLTIP')
  },
  feedMessageAttachFiles ({ commit }, files) {
    commit('FEED_MESSAGE_ATTACH_FILES', files)
  },
  feedMessageRemoveFile ({ commit }, data) {
    commit('FEED_MESSAGE_REMOVE_FILE', data)
  },
  feedMessageToggleLinkTooltip ({ commit }) {
    commit('TOGGLE_FEED_MESSAGE_LINK_TOOLTIP')
    commit('CLOSE_FEED_MESSAGE_TAG_TOOLTIP')
  },
  feedMessageCloseLinkTooltip ({ commit }) {
    commit('CLOSE_FEED_MESSAGE_LINK_TOOLTIP')
  },
  feedMessageSetLinkText ({ commit }, text) {
    commit('SET_FEED_MESSAGE_LINK_TEXT', text)
  },
  feedMessageSetLinkUrl ({ commit }, url) {
    commit('SET_FEED_MESSAGE_LINK_URL', url)
  },
  feedMessageAttachLink ({ commit, state }) {
    const text = state.messageArea.attachment.linkTooltip.text
    const url = state.messageArea.attachment.linkTooltip.url
    if (text && url) {
      commit('CLOSE_FEED_MESSAGE_LINK_TOOLTIP')
    } else if (!text) {
      commit('SET_FEED_MESSAGE_LINK_TEXT_VALID', { type: 'error', message: 'Поле не заполнено' })
    } else {
      commit('SET_FEED_MESSAGE_LINK_URL_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  feedMessageToggleTagTooltip ({ commit }) {
    commit('TOGGLE_FEED_MESSAGE_TAG_TOOLTIP')
    commit('CLOSE_FEED_MESSAGE_LINK_TOOLTIP')
  },
  feedMessageCloseTagTooltip ({ commit }) {
    commit('CLOSE_FEED_MESSAGE_TAG_TOOLTIP')
  },
  feedMessageSetTagText ({ commit }, text) {
    commit('SET_FEED_MESSAGE_TAG_TEXT', text)
  },
  feedMessageAttachTag ({ commit, state }) {
    if (state.messageArea.attachment.tagTooltip.text) {
      commit('FEED_MESSAGE_ATTACH_TAG')
      commit('CLOSE_FEED_MESSAGE_TAG_TOOLTIP')
    } else {
      commit('SET_FEED_MESSAGE_TAG_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  feedMessageRemoveTag ({ commit }, index) {
    commit('FEED_MESSAGE_REMOVE_TAG', index)
  },
  feedMessageAttachmentClearValidation ({ commit }) {
    commit('CLEAR_FEED_MESSAGE_ATTACHMENT_VALID')
  },
  toggleFeedPostControls ({ commit }, postId) {
    commit('TOGGLE_FEED_POST_CONTROLS', postId)
  },
  updateFeedPost ({ commit, dispatch, state }, data) {
    switch (data.type) {
      case 'EventMessage':
        commit('SET_FEED_POST_DATA_TO_UPDATE', data)
        commit('SHOW_FEED_MESSAGE_AREA')
        break
      case 'Activity': {
        axios.get(`${url}/activities/${data.itemableId}?expand=files,users,groups,departments`, config).then(response => {
          commit('SET_FEED_EVENT_MODAL_DATA_TO_UPDATE', response.data.data)
          commit('SHOW_FEED_EVENT_MODAL')
        }).catch(error => {
          console.log('ошибка получения мероприятия для редактирования', error)
        })
        break
      }
      case 'Poll': {
        dispatch('[feed-poll] getForUpdate', data.itemableId)
        break
      }
      default: break
    }
    commit('CLOSE_FEED_POST_CONTROLS')
  },
  removeFeedPost ({ commit, state }, postId) {
    axios.delete(`${url}/event-items/${postId}`, config).then(response => {
      // удаляем из стейта и не запрашиваем заного с сервера, иначе будут дубликаты при пагинации
      commit('REMOVE_FEED_POST_FROM_STATE', postId)
    }).catch(error => {
      console.log('ошибка удаления поста', error)
    })
  },

  // мероприятия
  showFeedEventModal ({ commit }, date) {
    const convertDate = moment(date).format('YYYY-MM-DD HH:mm')

    commit('SET_FEED_EVENT_START_DATE', convertDate)
    commit('SET_FEED_EVENT_FINISH_DATE', convertDate)
    commit('SHOW_FEED_EVENT_MODAL')
  },
  closeFeedEventModal ({ commit }) {
    commit('CLOSE_FEED_EVENT_MODAL')
    commit('CLOSE_FEED_EVENT_LINK_TOOLTIP')
    commit('CLOSE_FEED_EVENT_TAG_TOOLTIP')
  },
  clearFeedEventModal ({ commit }) {
    commit('CLEAR_FEED_EVENT_MODAL')
  },
  setFeedEventName ({ commit }, name) {
    commit('SET_FEED_EVENT_NAME', name)
  },
  setFeedEventDescription ({ commit }, description) {
    commit('SET_FEED_EVENT_DESCRIPTION', description)
  },
  feedEventModalToggleLinkTooltip ({ commit }) {
    commit('TOGGLE_FEED_EVENT_LINK_TOOLTIP')
    commit('CLOSE_FEED_EVENT_TAG_TOOLTIP')
  },
  feedEventModalCloseLinkTooltip ({ commit }) {
    commit('CLOSE_FEED_EVENT_LINK_TOOLTIP')
  },
  feedEventModalSetLinkText ({ commit }, text) {
    commit('SET_FEED_EVENT_LINK_TEXT', text)
  },
  feedEventModalSetLinkUrl ({ commit }, url) {
    commit('SET_FEED_EVENT_LINK_URL', url)
  },
  feedEventModalToggleTagTooltip ({ commit }) {
    commit('CLOSE_FEED_EVENT_LINK_TOOLTIP')
    commit('TOGGLE_FEED_EVENT_TAG_TOOLTIP')
  },
  feedEventModalCloseTagTooltip ({ commit }) {
    commit('CLOSE_FEED_EVENT_TAG_TOOLTIP')
  },
  feedEventModalSetTagText ({ commit }, text) {
    commit('SET_FEED_EVENT_TAG_TEXT', text)
  },
  feedEventModalAttachFiles ({ commit }, files) {
    commit('FEED_EVENT_ATTACH_FILES', files)
  },
  feedEventModalRemoveFile ({ commit }, data) {
    commit('FEED_EVENT_REMOVE_FILE', data)
  },
  feedEventModalAttachLink ({ commit, state }) {
    const text = state.eventModal.attachment.linkTooltip.text
    const url = state.eventModal.attachment.linkTooltip.url
    if (text && url) {
      commit('CLOSE_FEED_EVENT_LINK_TOOLTIP')
    } else if (!text) {
      commit('SET_FEED_EVENT_LINK_TEXT_VALID', { type: 'error', message: 'Поле не заполнено' })
    } else {
      commit('SET_FEED_EVENT_LINK_URL_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  feedEventModalAttachTag ({ commit, state }) {
    if (state.eventModal.attachment.tagTooltip.text) {
      commit('FEED_EVENT_ATTACH_TAG')
      commit('CLOSE_FEED_EVENT_TAG_TOOLTIP')
    } else {
      commit('SET_FEED_EVENT_TAG_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  feedEventModalRemoveTag ({ commit }, index) {
    commit('FEED_EVENT_REMOVE_TAG', index)
  },
  setFeedEventStartDate ({ commit }, date) {
    commit('SET_FEED_EVENT_START_DATE', date)
  },
  setFeedEventFinishDate ({ commit }, date) {
    commit('SET_FEED_EVENT_FINISH_DATE', date)
  },
  setFeedEventPlace ({ commit }, place) {
    commit('SET_FEED_EVENT_PLACE', place)
  },
  setFeedEventReminder ({ commit }, reminder) {
    commit('SET_FEED_EVENT_REMINDER', reminder)
  },
  '[feed-event] getRecipientUserOptions' ({ commit, state }) {
    const userParams = {
      pagination: {
        currentPage: 1,
        perPage: 40
      },
      filter: {
        search: `search[all]=${state.eventModal.recipients.userSearch}`
      }
    }
    dictionariesApi.getUserOptionList(userParams).then(response => {
      var data = response.data.data

      state.eventModal.recipients.tabs.users.forEach(user => {
        if (!response.data.data.some(item => item.id === user.id)) {
          data.push(user)
        }
      })
      commit('SET_FEED_EVENT_RECIPIENTS_USERS_OPTIONS', data)
    }).catch(error => {
      console.log('ошибка получения списка сотрудников для компонента "получатели"', error.response ? error.response : error)
    })
  },
  '[feed-event] setUserRecipientSearch' ({ dispatch, commit }, value) {
    commit('[feed-event] SET_USER_RECIPIENT_SEARCH', value)
    dispatch('[feed-event] getRecipientUserOptions')
  },
  toggleFeedEventRecipientSelected ({ commit }, recipient) {
    commit('TOGGLE_FEED_EVENT_SELECTED_RECIPIENT', recipient)
  },
  toggleFeedEventRecipientsSelect ({ commit }) {
    commit('TOGGLE_FEED_EVENT_RECIPIENTS')
  },
  closeFeedEventRecipientsSelect ({ commit }) {
    commit('CLOSE_FEED_EVENT_RECIPIENTS')
  },
  saveEvent ({ commit, dispatch, state, rootState }) {
    // reminder пока что не используется. Паша просил отправлять ему дату и время, когда нужно будет напоминать
    const reminderDate = () => {
      const reminderDate = new Date(state.eventModal.date_start)

      switch (state.eventModal.reminder.value.id) {
        case 1:
          reminderDate.setMinutes(reminderDate.getMinutes() - 10080)
          break
        case 2:
          reminderDate.setMinutes(reminderDate.getMinutes() - 1440)
          break
        case 3:
          reminderDate.setMinutes(reminderDate.getMinutes() - 60)
          break
        default:
          return false
      }
      return formatDateForServer(reminderDate)
    }

    const recipientDepartments = state.eventModal.recipients.selected.filter(item => {
      return item.recipient_id.split('_').pop() === 'department'
    }).map(department => {
      return department.id
    })
    const recipientGroups = state.eventModal.recipients.selected.filter(item => {
      return item.recipient_id.split('_').pop() === 'group'
    }).map(group => {
      return group.id
    })
    const recipientUsers = state.eventModal.recipients.selected.filter(item => {
      return item.recipient_id.split('_').pop() === 'user'
    }).map(user => {
      return user.id
    })
    const remindAt = reminderDate()

    if (!state.eventModal.updatedId) {
      // вновь создаваемое мероприятие
      const postData = {
        name: state.eventModal.name,
        description: clearUserHtml(state.eventModal.description, false),
        address: state.eventModal.place,
        start_at: state.eventModal.date_start,
        end_at: state.eventModal.date_finish,
        tags: state.eventModal.attachment.tags,
        department_ids: recipientDepartments,
        group_ids: recipientGroups,
        user_ids: recipientUsers,
        remind_at_object: state.eventModal.reminder.value
      }

      if (remindAt) {
        postData.remind_at = [remindAt]
      }

      const formData = new FormData()
      const files = state.eventModal.attachment.files

      for (let i = 0; i < files.length; ++i) {
        formData.append('files[]', files[i])
      }

      commit('[feed-event] REQUEST_START')
      axios.post(`${url}/activities`, postData, config).then(response => {
        // обновление данных на странице календаря, в профиле
        commit('[user-calendar] SET_INITIAL_ACTIVITIES')
        dispatch('[user-calendar] getActivities')

        if (files.length !== 0) {
          axios.post(`${url}/activities/${response.data.data.id}/files`, formData, configMultipart).then(response => {
            commit('[feed-event] REQUEST_SUCCESS')
            commit('CLEAR_FEED_EVENT_VALIDATION')
            commit('CLEAR_FEED_EVENT_MODAL')
            commit('CLOSE_FEED_EVENT_MODAL')
            this.dispatch('getFeedPosts')
            document.body.classList.remove('loadingData')
          }).catch(error => {
            commit('[feed-event] REQUEST_FAILURE')
            showAlertWarning(error.response.data.data.message)
            document.body.classList.remove('loadingData')
          })
        } else {
          commit('[feed-event] REQUEST_SUCCESS')
          commit('CLEAR_FEED_EVENT_VALIDATION')
          commit('CLEAR_FEED_EVENT_MODAL')
          commit('CLOSE_FEED_EVENT_MODAL')
          this.dispatch('getFeedPosts')
        }
      }).catch(error => {
        commit('[feed-event] REQUEST_FAILURE')
        showAlertWarning(error.response.data.data.message)
        document.body.classList.remove('loadingData')

        if (error.response.status === 422) {
          commit('SET_FEED_EVENT_VALIDATION', error.response.data.validation)
        }
      })
    } else {
      // редактируемое мероприятие
      // для добавления файлов нужно отправлять POST на /activities/{ itemable_id }/files
      const itemableId = state.eventModal.updatedId
      const updateData = {
        name: state.eventModal.name,
        description: clearUserHtml(state.eventModal.description, false),
        tags: state.eventModal.attachment.tags,
        start_at: formatDateForServer(state.eventModal.date_start),
        end_at: formatDateForServer(state.eventModal.date_finish),
        address: state.eventModal.place,
        department_ids: recipientDepartments,
        group_ids: recipientGroups,
        user_ids: recipientUsers,
        remind_at_object: state.eventModal.reminder.value
      }

      const formData = new FormData()
      // выбираем только вновь добавленные файлы у которых нет id чтобы не заливать дубли на серв
      const newFiles = state.eventModal.attachment.files.filter(file => {
        return file.id === undefined
      })
      for (let i = 0; i < newFiles.length; ++i) {
        formData.append('files[]', newFiles[i])
      }

      const removeEventFiles = state.eventModal.attachment.filesToRemove.map(id => {
        return axios.delete(`${url}/files/${id}`, config)
      })
      const attachNewFiles = newFiles.length !== 0 ? axios.post(`${url}/activities/${itemableId}/files`, formData, configMultipart) : false
      const updateMessageData = axios.put(`${url}/activities/${itemableId}`, updateData, config)

      commit('[feed-event] REQUEST_START')
      axios.all([removeEventFiles, attachNewFiles, updateMessageData]).then(response => {
        commit('[feed-event] REQUEST_SUCCESS')
        commit('CLEAR_FEED_EVENT_VALIDATION')
        commit('CLEAR_FEED_EVENT_MODAL')
        commit('CLOSE_FEED_EVENT_MODAL')
        this.dispatch('getFeedPosts')
        document.body.classList.remove('loadingData')
        // обновление данных на странице календаря, в профиле
        commit('[user-calendar] SET_INITIAL_ACTIVITIES')
        dispatch('[user-calendar] getActivities')
      }).catch(error => {
        commit('[feed-event] REQUEST_FAILURE')
        console.log('ошибка редактирования мероприятия в ленте', error.response.data.validation)
        document.body.classList.remove('loadingData')
      })
    }
  },
  clearFeedEventValidation ({ commit }) {
    commit('CLEAR_FEED_EVENT_VALIDATION')
  },

  // модалка опроса
  async '[feed-poll] saveInfo' ({ dispatch, commit, state, rootState }) {
    const defaultPollOptionsFiled = state.pollModal.options[0].name && state.pollModal.options[1].name

    // нужно проверить сразу на фронте что дефолтные варианты заполнены
    if (!defaultPollOptionsFiled) {
      commit('[feed-poll] SET_OPTIONS_ERROR')
    } else {
      commit('[feed-poll] MODAL_REQUEST_START')

      const recipientDepartmentsIds = state.pollModal.recipients.selected.filter(item => {
        return item.recipient_id.split('_').pop() === 'department'
      }).map(department => {
        return department.id
      })
      const recipientGroupsIds = state.pollModal.recipients.selected.filter(item => {
        return item.recipient_id.split('_').pop() === 'group'
      }).map(group => {
        return group.id
      })
      const recipientUsersIds = state.pollModal.recipients.selected.filter(item => {
        return item.recipient_id.split('_').pop() === 'user'
      }).map(user => {
        return user.id
      })
      const targetIds = new Set()
      // нужно сразу добавить в получатели себя иначе с каких-то х*ев это не делается на беке
      recipientUsersIds.forEach(id => targetIds.add(id))
      if (targetIds.size) targetIds.add(rootState.appData.currentUser.id)

      // это всё гавно с запросами для получения списка юзеров из групп и отделов написано потому что Паша ленивая жопа
      // и не удосужился сделать нормально, хотябы как это реализовано для "мероприятий"
      if (recipientDepartmentsIds.length !== 0) {
        for (const id of recipientDepartmentsIds) {
          await axios.get(`${url}/departments/${id}?expand=users`, config).then(response => {
            if (response.data.data.head_id) {
              targetIds.add(response.data.data.head_id)
            }
            if (response.data.data.users) {
              response.data.data.users.forEach(user => targetIds.add(user.id))
            }
          }).catch(error => {
            console.log('ошибка получения отдела чтобы вытащить оттуда получателей для опроса', error.response ?? error)
          })
        }
      }
      if (recipientGroupsIds.length !== 0) {
        for (const id of recipientGroupsIds) {
          await axios.get(`${url}/groups/${id}?expand=users`, config).then(response => {
            if (response.data.data.users) {
              response.data.data.users.forEach(user => targetIds.add(user.id))
            }
          }).catch(error => {
            console.log('ошибка получения группы чтобы вытащить оттуда получателей для опроса', error.response ?? error)
          })
        }
      }

      if (!state.pollModal.updatedId) {
        // создание опроса
        const postData = {
          name: state.pollModal.question,
          description: state.pollModal.description,
          target_ids: Array.from(targetIds),
          department_ids: [...recipientDepartmentsIds],
          settings: {
            is_open: state.pollModal.isOpen,
            is_multiple: state.pollModal.isMultiple
          }
        }

        pollsApi.create(postData).then((response) => {
          const pollId = response.data.data.id
          const pollOptions = state.pollModal.options

          async function creatPollOptions () {
            for (const option of pollOptions) {
              const postData = {
                poll_id: pollId,
                name: option.name
              }

              await pollsApi.createOption(postData).then(() => {})
                .catch(error => {
                  console.log('ошибка создания вопроса в цикле', error.response ?? error)
                  throw error
                })
            }
          }

          creatPollOptions().then(() => {
            dispatch('[feed-poll] saveInfoSuccess')
          }).catch(error => {
            dispatch('[feed-poll] saveInfoFailure', error?.response?.data.validation)
            console.log('ошибка создания опроса (создание вариантов)', error.response ?? error)
          })
        }).catch(error => {
          dispatch('[feed-poll] saveInfoFailure', error?.response?.data.validation)
          console.log('ошибка создания опроса', error.response ?? error)
        })
        console.log('postData', postData)
      } else {
        // редактирование опроса
        const params = {
          id: state.pollModal.updatedId,
          updateData: {
            name: state.pollModal.question,
            description: state.pollModal.description,
            target_ids: Array.from(targetIds),
            department_ids: [...recipientDepartmentsIds],
            settings: {
              is_open: state.pollModal.isOpen,
              is_multiple: state.pollModal.isMultiple
            }
          }
        }

        pollsApi.update(params).then((response) => {
          const pollId = params.id
          const newPollOptions = state.pollModal.options.filter(option => option.id === null)
          const updatedPollOptions = state.pollModal.options.filter(option => option.id !== null)
          const optionsToRemove = state.pollModal.optionsToRemove

          async function updatePollOptions () {
            if (newPollOptions.length !== 0) {
              for (const option of newPollOptions) {
                const postData = {
                  poll_id: pollId,
                  name: option.name
                }

                await pollsApi.createOption(postData).then(() => {})
                  .catch(error => {
                    console.log('ошибка создания вопроса в цикле (редактирование опроса)', error.response ?? error)
                    throw error
                  })
              }
            }
            if (updatedPollOptions.length !== 0) {
              for (const option of updatedPollOptions) {
                const params = {
                  id: option.id,
                  updateData: {
                    name: option.name
                  }
                }

                await pollsApi.updateOption(params).then(() => {})
                  .catch(error => {
                    console.log('ошибка удаления вопроса в цикле (редактирование опроса)', error.response ?? error)
                    throw error
                  })
              }
            }
            if (optionsToRemove.length !== 0) {
              for (const id of optionsToRemove) {
                await pollsApi.removeOption(id).then(() => {})
                  .catch(error => {
                    console.log('ошибка удаления вопроса в цикле (редактирование опроса)', error.response ?? error)
                    throw error
                  })
              }
            }
          }

          updatePollOptions().then(() => {
            dispatch('[feed-poll] saveInfoSuccess')
          }).catch(error => {
            dispatch('[feed-poll] saveInfoFailure', error?.response?.data.validation)
            console.log('ошибка редактирования опроса (редактирование/добавление/удаление вариантов)', error.response ?? error)
          })
        }).catch(error => {
          dispatch('[feed-poll] saveInfoFailure', error?.response?.data.validation)
          console.log('ошибка редактирования опроса', error.response ?? error)
        })
        console.log('params', params)
      }
    }
  },

  '[feed-poll] saveInfoSuccess' ({ commit, dispatch }) {
    commit('[feed-poll] MODAL_REQUEST_FINISHED')
    commit('[feed-poll] CLOSE_MODAL')
    commit('[feed-poll] CLEAR_MODAL')
    dispatch('getFeedPosts')
  },

  '[feed-poll] saveInfoFailure' ({ commit }, errors) {
    commit('[feed-poll] MODAL_REQUEST_FINISHED')
    commit('[feed-poll] SET_VALIDATION', errors)
  },

  '[feed-poll] getRecipientUserOptions' ({ commit, state }) {
    const userParams = {
      pagination: {
        currentPage: 1,
        perPage: 40
      },
      filter: {
        search: `search[all]=${state.pollModal.recipients.userSearch}`
      }
    }
    dictionariesApi.getUserOptionList(userParams).then(response => {
      commit('[feed-poll] SET_RECIPIENTS_USERS_OPTIONS', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка сотрудников для компонента "получатели"', error.response ? error.response : error)
    })
  },

  '[feed-poll] setUserRecipientSearch' ({ dispatch, commit }, value) {
    commit('[feed-poll] SET_USER_RECIPIENT_SEARCH', value)
    dispatch('[feed-poll] getRecipientUserOptions')
  },

  '[feed-poll] vote' ({ commit, dispatch }, payload) {
    commit('[feed-poll] VOTE_REQUEST_START', payload.postId)
    /* const pollId = payload.pollId */
    const answers = payload.answers

    async function creatPollAnswers () {
      const postData = {
        poll_option_id: answers
      }
      await pollsApi.createAnswer(postData).then(() => {})
        .catch(error => {
          console.log('ошибка создания ответа на опрос в цикле', error.response ?? error)
          throw error
        })
    }

    creatPollAnswers().then(() => {
      dispatch('[feed-poll] voteSuccess', payload)
    }).catch(error => {
      dispatch('[feed-poll] voteFailure', payload.postId)
      console.log('общая ошибка создания ответов', error)
    })
  },

  '[feed-poll] voteSuccess' ({ commit, dispatch }, payload) {
    commit('[feed-poll] VOTE_REQUEST_FINISHED', payload.postId)
    dispatch('[feed-poll] updateVotedAnswers', payload)
  },

  '[feed-poll] voteFailure' ({ commit, dispatch }, postId) {
    commit('[feed-poll] VOTE_REQUEST_FINISHED', postId)
  },

  '[feed-poll] updateVotedAnswers' ({ commit }, payload) {
    pollsApi.getPollAnswers(payload.pollId).then(response => {
      commit('[feed-poll] UPDATE_VOTED_ANSWERS', { ...payload, answers: response.data.data })
    }).catch(error => {
      console.log('ошибка получения ответов на опрос после голосования', error.response ?? error)
    })
  },

  '[feed-poll] getForUpdate' ({ commit }, itemableId) {
    pollsApi.getSingle(itemableId).then(response => {
      const poll = response.data.data

      pollsApi.getPollAnswers(poll.id).then(response => {
        const pollWithAnswers = {
          ...poll,
          answers: response.data.data
        }

        commit('[feed-poll] SET_FOR_UPDATE', pollWithAnswers)
        commit('[feed-poll] OPEN_MODAL')
      })
    }).catch(error => {
      console.log('ошибка получения опроса для редактирования', error.response ?? error)
    })
  },
  // /модалка опроса

  // поиск и фильтрация в ленте
  setFeedSearchValue ({ commit }, value) {
    commit('SET_FEED_SEARCH_VALUE', value)
    this.dispatch('getFeedPosts')
  },
  toggleFeedFilter ({ commit }) {
    commit('TOGGLE_FEED_FILTER')
  },
  closeFeedFilter ({ commit }) {
    commit('CLOSE_FEED_FILTER')
  },
  clearFeedFilter ({ commit }) {
    commit('CLEAR_FEED_FILTER')
    this.dispatch('resetFeedContent')
    this.dispatch('getFeedPosts')
  },
  setFeedFilterDateFrom ({ commit }, date) {
    commit('SET_FEED_FILTER_DATE_FROM', date)
  },
  setFeedFilterDateTo ({ commit }, date) {
    commit('SET_FEED_FILTER_DATE_TO', date)
  },
  setFeedFilterPostAuthor ({ commit }, author) {
    commit('SET_FEED_FILTER_POST_AUTHOR', author)
  },
  setFeedFilterPostRecipient ({ commit }, recipient) {
    commit('SET_FEED_FILTER_POST_RECIPIENT', recipient)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
